module.exports = __webpack_public_path__ + "static/media/ota-thumbnail.bd15f542.svg";